export default "__VITE_ASSET__7c04c122__"